import request from '@/common/request'

class FilialService {
  getAll() {
    return request.get('/filiais')
  }

  getByEmpresa(empresaId, status) {
    return request.get(`/filiais/empresas/${empresaId}`, {
      params: {
        status
      }
    })
  }

  create(data) {
    return request.post('/filiais', data)
  }

  update(data) {
    return request.put('/filiais', data)
  }

  deleteById(id) {
    return request.delete(`/filiais/${id}`)
  }
}

export default new FilialService()
